import * as React from "react";
import {Col, Form, Input, Row} from "antd";
import {createRequest, updateRequest} from "@actions/trackerPolicy";
import {TrackerPolicy} from "@models/trackerPolicy";
import withFormWrapper from "../../hocs/withFormWrapper";
import {FormattedMessage} from "react-intl";
import DatePicker from "react-datepicker2";
import TextEditor, {TextEditorRef} from "@components/custom/TextEditor";
import moment from "moment-jalaali";
import {toUTC, showDate} from '@utils';



interface PropsFromState {
  loading: boolean;
  errors?: string;
  form: any;
  trackerPolicy?: TrackerPolicy;
}

interface PropsFromDispatch {
  createRequest: typeof createRequest;
  updateRequest: typeof updateRequest;
}

type TrackerPolicyFormAllProps = PropsFromState & PropsFromDispatch;

type TrackerPolicyFormStateShape = {
  description: string;
  id: string;
  title: string;
  start_track_date_time:string
};

class TrackerPolicyForm extends React.Component<TrackerPolicyFormAllProps, TrackerPolicyFormStateShape> {
  
  private textEditorRef = React.createRef<TextEditorRef>();
  
  constructor(props) {
    super(props);
    const {trackerPolicy} = props;
    this.state = {
      ...this.getStateFromProps(trackerPolicy)
    };
  }
  
  getStateFromProps = (trackerPolicy: TrackerPolicy | null): object => {
    const obj = trackerPolicy || {};
    return {
      title: obj.title || "",
      description: obj.description || "",
      start_track_date_time: !!obj.start_track_date_time ? moment(showDate(obj.start_track_date_time)) : null,
      id: obj.id || ""
    };
  };
  
  getValues = () => {
    let returnValues = null;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        returnValues = {
          ...values,
        };
      }
    });
    
    return {
      payload: returnValues,
      id: this.props.trackerPolicy ? this.props.trackerPolicy.id : null,
    };
  };
  
  onChangeDate = date => {
    this.props.form.setFieldsValue({
      "start_track_date_time": date
    })
  };
  
  
  render() {
    const {getFieldDecorator} = this.props.form;
    return (
      <Form>
        <Row>
          <Col span={12}>
            <Form.Item label={<FormattedMessage id="app.title" defaultMessage={`Title`}/>}>
              {getFieldDecorator("title", {
                initialValue: this.state.title,
                rules: [{
                  whitespace: true,
                  required: true,
                  message: (
                    <FormattedMessage
                      id="app.title_is_required"
                      defaultMessage={`Title is required`}
                    />
                  )
                }]
              })(<Input/>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label={<FormattedMessage
              id="app.start_track_date"
              defaultMessage={`Start track date`}
            />}>
              {getFieldDecorator("start_track_date_time", {
                // initialValue: moment(this.state.start_track_date_time),
                rules: [{
                  required: true,
                  message: (
                    <FormattedMessage
                      id="app.start_date_is_required"
                      defaultMessage={`Start date is required!`}
                    />
                  )
                }
                ]
              })(<Input type={`hidden`}/>)}
              <DatePicker
                isGregorian={false}
                timePicker={true}
                value={this.state.start_track_date_time}
                onChange={this.onChangeDate}
              />{" "}
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={<FormattedMessage id="app.description" defaultMessage={`Description`}/>}
            >
              {getFieldDecorator("description")(
                <TextEditor ref={this.textEditorRef} text={this.state.description}/>
              )}
            </Form.Item>
  
          </Col>
        </Row>
      </Form>
    );
  }
}

export default withFormWrapper(Form.create({name: "trackerPolicy-form"})(TrackerPolicyForm));
